import { Record as record } from 'immutable';
import _ from 'lodash';

import { construct, fields, resolveAll } from '../helpers/LinkMapper';

export class Stage {
    name = null;
    title = null;
    text = null;
    image = false;
    video = null;

    constructor (params = {}) {
        _.forOwn(this, (value, key) => {
            if (params[key]) {
                this[key] = params[key];
            }
        });
    }

    static fromJSON (json = {}) {
        return new Stage(json);
    }
}

const defaults = {
    name: null,
    defaultOpen: true,
    currentIndex: 0,
    hideProgression: false,
    stages: []
};

class Tutorial extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(Tutorial, json, {
            name: fields.string,
            defaultOpen: fields.boolean,
            currentIndex: 0,
            hideProgression: fields.boolean,
            stages: resolveAll.as(Stage)
        });
    }

    hasNext () {
        return this.stages.count() && this.stages.count() > this.currentIndex + 1;
    }

    hasPrev () {
        return this.stages.count() && this.currentIndex > 0;
    }

    goTo (targetStageName) {
        const index = this.stages.findIndex((stage) => stage.name === targetStageName);
        if (index > -1) {
            return this.setCurrentStage(index);
        }
        return this;
    }

    getCurrentStage () {
        return this.stages.get(this.currentIndex);
    }

    setCurrentStage (stageIndex) {
        return this.set('currentIndex', stageIndex);
    }

    moveToNext () {
        if (this.hasNext()) {
            return this.setCurrentStage(this.currentIndex + 1);
        }
        return this;
    }

    moveToPrev () {
        if (this.hasPrev()) {
            return this.setCurrentStage(this.currentIndex - 1);
        }
        return this;
    }

    stageCount() {
        return this.stages.count();
    }

    showToggle() {
        return this.defaultOpen;
    }
}

export default Tutorial;
